import { render } from "./PadlockToggle.vue?vue&type=template&id=524bfb7d"
import script from "./PadlockToggle.vue?vue&type=script&lang=js"
export * from "./PadlockToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__